import React, { useState, useEffect } from "react";
import { Container, StyledCloseIcon, TextDiv, StyledButton } from "./alert-container.styled";

export const TRANSITION_MS = 1000;

export default function AlertContainer({ changeText, onAccept, onClose, setVisible }) {
    const [isVisible, setIsVisible] = useState(false);
    const [styles, setStyles] = useState({
        opacity: 0,
        transition: "",
    });
    const opacityTransition = `all ${TRANSITION_MS}ms ease`;

    useEffect(() => {
        if (setVisible && !isVisible) {
            setIsVisible(true);
            setStyles({ opacity: 0, transition: opacityTransition });

            requestAnimationFrame(() => {
                setStyles({ opacity: 1, transition: opacityTransition });
            });
        }

        if (!setVisible && isVisible) {
            setStyles({ opacity: 0, transition: "unset" });
            setIsVisible(false);
        }
    }, [setVisible, isVisible]);

    return (
        <Container
            opacity={styles.opacity}
            display={isVisible ? "flex" : "none"}
            transition={styles.transition}
        >
            <StyledCloseIcon onClick={onClose} />
            <TextDiv>
                El cambio a <strong>{changeText}</strong> eliminará los productos del carrito. ¿Desea continuar?
            </TextDiv>
            <StyledButton onClick={onAccept} variant="contained">
                Aceptar
            </StyledButton>
        </Container>
    );
}
